import React, { useContext } from 'react';
import { Col, Nav, Row } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { domainPrices } from '../../resources/static';
import { CurrencyContext } from '../../utils/currencyContext';
import getCurrencySign from '../../utils/getCurrencySign';
import './domainWidget.scss';

function DomainWidget() {
    const { t } = useTranslation();
    const { currentCurrency } = useContext(CurrencyContext);
    const sign = getCurrencySign(currentCurrency);
    const domainData = domainPrices[currentCurrency];

    return (
        <div className="domain-columns-wrapper">
            <Row>
                <Col md={6}>
                    <table className="tld-table">
                        <thead>
                            <tr className="domain-table-title">
                                <th scope="col">{t('domain-page.tlds-table.column-title-1')}</th>
                                <th scope="col">{t('domain-page.tlds-table.column-title-2')}</th>
                                <th scope="col">{t('domain-page.tlds-table.column-title-3')}</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr className="row-com">
                                <td className="tld">
                                    <div className="saletop gb-label--sale">
                                        <span>{t('domain-page.tlds-table.popular')}</span>
                                    </div>
                                    <strong>.com</strong>
                                </td>
                                <td>
                                    <strong>
                                        {domainData.com}
                                        {sign}
                                    </strong>
                                    <small>/{t('titles.year')}</small>
                                    <div className="renewal">
                                        {t('domain-page.tlds-table.renewal')}: {domainData.com}
                                        {sign}
                                    </div>
                                </td>
                                <td>
                                    <strong>
                                        {domainData.com}
                                        {sign}
                                    </strong>
                                    <div className="renewal">
                                        {t('domain-page.tlds-table.year-included')}
                                    </div>
                                </td>
                            </tr>
                            <tr className="row-net">
                                <td className="tld">
                                    <div className="saletop gb-label--sale">
                                        <span>{t('domain-page.tlds-table.popular')}</span>
                                    </div>
                                    <strong>.net</strong>
                                </td>
                                <td>
                                    <strong>
                                        {domainData.net}
                                        {sign}
                                    </strong>
                                    <small>/{t('titles.year')}</small>
                                    <div className="renewal">
                                        {t('domain-page.tlds-table.renewal')}: {domainData.net}
                                        {sign}
                                    </div>
                                </td>
                                <td>
                                    <strong>
                                        {domainData.net}
                                        {sign}
                                    </strong>
                                    <div className="renewal">
                                        {t('domain-page.tlds-table.year-included')}
                                    </div>
                                </td>
                            </tr>
                            <tr className="row-be">
                                <td className="tld">
                                    <div className="saletop gb-label--sale">
                                        <span>{t('domain-page.tlds-table.popular')}</span>
                                    </div>
                                    <strong>.be</strong>
                                </td>
                                <td>
                                    <strong>
                                        {domainData.be}
                                        {sign}
                                    </strong>
                                    <small>/{t('titles.year')}</small>
                                    <div className="renewal">
                                        {t('domain-page.tlds-table.renewal')}: {domainData.be}
                                        {sign}
                                    </div>
                                </td>
                                <td>
                                    <strong>
                                        {domainData.be}
                                        {sign}
                                    </strong>
                                    <div className="renewal">
                                        {t('domain-page.tlds-table.year-included')}
                                    </div>
                                </td>
                            </tr>
                            <tr className="row-de">
                                <td className="tld">
                                    <div className="saleeu gb-label--sale">
                                        <span>{t('domain-page.tlds-table.europe')}</span>
                                    </div>
                                    <strong>.de</strong>
                                </td>
                                <td>
                                    <strong>
                                        {domainData.de}
                                        {sign}
                                    </strong>
                                    <small>/{t('titles.year')}</small>
                                    <div className="renewal">
                                        {t('domain-page.tlds-table.renewal')}: {domainData.de}
                                        {sign}
                                    </div>
                                </td>
                                <td>
                                    <strong>
                                        {domainData.de}
                                        {sign}
                                    </strong>
                                    <div className="renewal">
                                        {t('domain-page.tlds-table.year-included')}
                                    </div>
                                </td>
                            </tr>
                            <tr className="row-it">
                                <td className="tld">
                                    <div className="saleeu gb-label--sale">
                                        <span>{t('domain-page.tlds-table.europe')}</span>
                                    </div>
                                    <strong>.it</strong>
                                </td>
                                <td>
                                    <strong>
                                        {domainData.it}
                                        {sign}
                                    </strong>
                                    <small>/{t('titles.year')}</small>
                                    <div className="renewal">
                                        {t('domain-page.tlds-table.renewal')}: {domainData.it}
                                        {sign}
                                    </div>
                                </td>
                                <td>
                                    <strong>
                                        {domainData.it}
                                        {sign}
                                    </strong>
                                    <div className="renewal">
                                        {t('domain-page.tlds-table.year-included')}
                                    </div>
                                </td>
                            </tr>
                            <tr className="row-uk">
                                <td className="tld">
                                    <div className="saleeu gb-label--sale">
                                        <span>{t('domain-page.tlds-table.europe')}</span>
                                    </div>
                                    <strong>.uk</strong>
                                </td>
                                <td>
                                    <strong>
                                        {domainData.uk}
                                        {sign}
                                    </strong>
                                    <small>/{t('titles.year')}</small>
                                    <div className="renewal">
                                        {t('domain-page.tlds-table.renewal')}: {domainData.uk}
                                        {sign}
                                    </div>
                                </td>
                                <td>
                                    <strong>
                                        {domainData.uk}
                                        {sign}
                                    </strong>
                                    <div className="renewal">
                                        {t('domain-page.tlds-table.year-included')}
                                    </div>
                                </td>
                            </tr>
                            <tr className="row-lu">
                                <td className="tld">
                                    <div className="saleeu gb-label--sale">
                                        <span>{t('domain-page.tlds-table.europe')}</span>
                                    </div>
                                    <strong>.lu</strong>
                                </td>
                                <td>
                                    <strong>
                                        {domainData.lu}
                                        {sign}
                                    </strong>
                                    <small>/{t('titles.year')}</small>
                                    <div className="renewal">
                                        {t('domain-page.tlds-table.renewal')}: {domainData.lu}
                                        {sign}
                                    </div>
                                </td>
                                <td>
                                    <strong>
                                        {domainData.lu}
                                        {sign}
                                    </strong>
                                    <div className="renewal">
                                        {t('domain-page.tlds-table.year-included')}
                                    </div>
                                </td>
                            </tr>
                            <tr className="row-biz">
                                <td className="tld">
                                    <div className="salegeneric gb-label--sale">
                                        <span>{t('domain-page.tlds-table.generic')}</span>
                                    </div>
                                    <strong>.biz</strong>
                                </td>
                                <td>
                                    <strong>
                                        {domainData.biz}
                                        {sign}
                                    </strong>
                                    <small>/{t('titles.year')}</small>
                                    <div className="renewal">
                                        {t('domain-page.tlds-table.renewal')}: {domainData.biz}
                                        {sign}
                                    </div>
                                </td>
                                <td>
                                    <strong>
                                        {domainData.biz}
                                        {sign}
                                    </strong>
                                    <div className="renewal">
                                        {t('domain-page.tlds-table.year-included')}
                                    </div>
                                </td>
                            </tr>
                            <tr className="row-tv">
                                <td className="tld">
                                    <div className="salegeneric gb-label--sale">
                                        <span>{t('domain-page.tlds-table.generic')}</span>
                                    </div>
                                    <strong>.tv</strong>
                                </td>
                                <td>
                                    <strong>
                                        {domainData.tv}
                                        {sign}
                                    </strong>
                                    <small>/{t('titles.year')}</small>
                                    <div className="renewal">
                                        {t('domain-page.tlds-table.renewal')}: {domainData.tv}
                                        {sign}
                                    </div>
                                </td>
                                <td>
                                    <strong>
                                        {domainData.tv}
                                        {sign}
                                    </strong>
                                    <div className="renewal">
                                        {t('domain-page.tlds-table.year-included')}
                                    </div>
                                </td>
                            </tr>
                            <tr className="row-me">
                                <td className="tld">
                                    <div className="salegeneric gb-label--sale">
                                        <span>{t('domain-page.tlds-table.generic')}</span>
                                    </div>
                                    <strong>.me</strong>
                                </td>
                                <td>
                                    <strong>
                                        {domainData.me}
                                        {sign}
                                    </strong>
                                    <small>/{t('titles.year')}</small>
                                    <div className="renewal">
                                        {t('domain-page.tlds-table.renewal')}: {domainData.me}
                                        {sign}
                                    </div>
                                </td>
                                <td>
                                    <strong>
                                        {domainData.me}
                                        {sign}
                                    </strong>
                                    <div className="renewal">
                                        {t('domain-page.tlds-table.year-included')}
                                    </div>
                                </td>
                            </tr>
                            <tr className="row-app">
                                <td className="tld">
                                    <div className="salegeneric gb-label--sale">
                                        <span>{t('domain-page.tlds-table.generic')}</span>
                                    </div>
                                    <strong>.app</strong>
                                </td>
                                <td>
                                    <strong>
                                        {domainData.app}
                                        {sign}
                                    </strong>
                                    <small>/{t('titles.year')}</small>
                                    <div className="renewal">
                                        {t('domain-page.tlds-table.renewal')}: {domainData.app}
                                        {sign}
                                    </div>
                                </td>
                                <td>
                                    <strong>
                                        {domainData.app}
                                        {sign}
                                    </strong>
                                    <div className="renewal">
                                        {t('domain-page.tlds-table.year-included')}
                                    </div>
                                </td>
                            </tr>
                            <tr className="row-ca">
                                <td className="tld">
                                    <div className="saleamerica gb-label--sale">
                                        <span>{t('domain-page.tlds-table.america')}</span>
                                    </div>
                                    <strong>.ca</strong>
                                </td>
                                <td>
                                    <strong>
                                        {domainData.ca}
                                        {sign}
                                    </strong>
                                    <small>/{t('titles.year')}</small>
                                    <div className="renewal">
                                        {t('domain-page.tlds-table.renewal')}: {domainData.ca}
                                        {sign}
                                    </div>
                                </td>
                                <td>
                                    <strong>
                                        {domainData.ca}
                                        {sign}
                                    </strong>
                                    <div className="renewal">
                                        {t('domain-page.tlds-table.year-included')}
                                    </div>
                                </td>
                            </tr>
                            <tr className="row-wf">
                                <td className="tld">
                                    <div className="salepacific gb-label--sale">
                                        <span>{t('domain-page.tlds-table.pacific')}</span>
                                    </div>
                                    <strong>.wf</strong>
                                </td>
                                <td>
                                    <strong>
                                        {domainData.wf}
                                        {sign}
                                    </strong>
                                    <small>/{t('titles.year')}</small>
                                    <div className="renewal">
                                        {t('domain-page.tlds-table.renewal')}: {domainData.wf}
                                        {sign}
                                    </div>
                                </td>
                                <td>
                                    <strong>
                                        {domainData.wf}
                                        {sign}
                                    </strong>
                                    <div className="renewal">
                                        {t('domain-page.tlds-table.year-included')}
                                    </div>
                                </td>
                            </tr>
                            <tr className="row-re">
                                <td className="tld">
                                    <div className="saleafrica gb-label--sale">
                                        <span>{t('domain-page.tlds-table.africa')}</span>
                                    </div>
                                    <strong>.re</strong>
                                </td>
                                <td>
                                    <strong>
                                        {domainData.re}
                                        {sign}
                                    </strong>
                                    <small>/{t('titles.year')}</small>
                                    <div className="renewal">
                                        {t('domain-page.tlds-table.renewal')}: {domainData.re}
                                        {sign}
                                    </div>
                                </td>
                                <td>
                                    <strong>
                                        {domainData.re}
                                        {sign}
                                    </strong>
                                    <div className="renewal">
                                        {t('domain-page.tlds-table.year-included')}
                                    </div>
                                </td>
                            </tr>
                            <tr className="row-ci">
                                <td className="tld">
                                    <div className="saleafrica gb-label--sale">
                                        <span>{t('domain-page.tlds-table.africa')}</span>
                                    </div>
                                    <strong>.ci</strong>
                                </td>
                                <td>
                                    <strong>
                                        {domainData.ci}
                                        {sign}
                                    </strong>
                                    <small>/{t('titles.year')}</small>
                                    <div className="renewal">
                                        {t('domain-page.tlds-table.renewal')}: {domainData.ci}
                                        {sign}
                                    </div>
                                </td>
                                <td>
                                    <strong>
                                        {domainData.ci}
                                        {sign}
                                    </strong>
                                    <div className="renewal">
                                        {t('domain-page.tlds-table.year-included')}
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </Col>
                <Col md={6}>
                    <table className="tld-table">
                        <thead>
                            <tr className="domain-table-title">
                                <th scope="col">{t('domain-page.tlds-table.column-title-1')}</th>
                                <th scope="col">{t('domain-page.tlds-table.column-title-2')}</th>
                                <th scope="col">{t('domain-page.tlds-table.column-title-3')}</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr className="row-fr">
                                <td className="tld">
                                    <div className="saletop gb-label--sale">
                                        <span>{t('domain-page.tlds-table.popular')}</span>
                                    </div>
                                    <strong>.fr</strong>
                                </td>
                                <td>
                                    <strong>
                                        {domainData.fr}
                                        {sign}
                                    </strong>
                                    <small>/{t('titles.year')}</small>
                                    <div className="renewal">
                                        {t('domain-page.tlds-table.renewal')}: {domainData.fr}
                                        {sign}
                                    </div>
                                </td>
                                <td>
                                    <strong>
                                        {domainData.fr}
                                        {sign}
                                    </strong>
                                    <div className="renewal">
                                        {t('domain-page.tlds-table.year-included')}
                                    </div>
                                </td>
                            </tr>
                            <tr className="row-org">
                                <td className="tld">
                                    <div className="saletop gb-label--sale">
                                        <span>{t('domain-page.tlds-table.popular')}</span>
                                    </div>
                                    <strong>.org</strong>
                                </td>
                                <td>
                                    <strong>
                                        {domainData.org}
                                        {sign}
                                    </strong>
                                    <small>/{t('titles.year')}</small>
                                    <div className="renewal">
                                        {t('domain-page.tlds-table.renewal')}: {domainData.org}
                                        {sign}
                                    </div>
                                </td>
                                <td>
                                    <strong>
                                        {domainData.org}
                                        {sign}
                                    </strong>
                                    <div className="renewal">
                                        {t('domain-page.tlds-table.year-included')}
                                    </div>
                                </td>
                            </tr>
                            <tr className="row-eu">
                                <td className="tld">
                                    <div className="saletop gb-label--sale">
                                        <span>{t('domain-page.tlds-table.popular')}</span>
                                    </div>
                                    <strong>.eu</strong>
                                </td>
                                <td>
                                    <strong>
                                        {domainData.eu}
                                        {sign}
                                    </strong>
                                    <small>/{t('titles.year')}</small>
                                    <div className="renewal">
                                        {t('domain-page.tlds-table.renewal')}: {domainData.eu}
                                        {sign}
                                    </div>
                                </td>
                                <td>
                                    <strong>
                                        {domainData.eu}
                                        {sign}
                                    </strong>
                                    <div className="renewal">
                                        {t('domain-page.tlds-table.year-included')}
                                    </div>
                                </td>
                            </tr>
                            <tr className="row-es">
                                <td className="tld">
                                    <div className="saleeu gb-label--sale">
                                        <span>{t('domain-page.tlds-table.europe')}</span>
                                    </div>
                                    <strong>.es</strong>
                                </td>
                                <td>
                                    <strong>
                                        {domainData.es}
                                        {sign}
                                    </strong>
                                    <small>/{t('titles.year')}</small>
                                    <div className="renewal">
                                        {t('domain-page.tlds-table.renewal')}: {domainData.es}
                                        {sign}
                                    </div>
                                </td>
                                <td>
                                    <strong>
                                        {domainData.es}
                                        {sign}
                                    </strong>
                                    <div className="renewal">
                                        {t('domain-page.tlds-table.year-included')}
                                    </div>
                                </td>
                            </tr>
                            <tr className="row-ch">
                                <td className="tld">
                                    <div className="saleeu gb-label--sale">
                                        <span>{t('domain-page.tlds-table.europe')}</span>
                                    </div>
                                    <strong>.ch</strong>
                                </td>
                                <td>
                                    <strong>
                                        {domainData.ch}
                                        {sign}
                                    </strong>
                                    <small>/{t('titles.year')}</small>
                                    <div className="renewal">
                                        {t('domain-page.tlds-table.renewal')}: {domainData.ch}
                                        {sign}
                                    </div>
                                </td>
                                <td>
                                    <strong>
                                        {domainData.ch}
                                        {sign}
                                    </strong>
                                    <div className="renewal">
                                        {t('domain-page.tlds-table.year-included')}
                                    </div>
                                </td>
                            </tr>
                            <tr className="row-nl">
                                <td className="tld">
                                    <div className="saleeu gb-label--sale">
                                        <span>{t('domain-page.tlds-table.europe')}</span>
                                    </div>
                                    <strong>.nl</strong>
                                </td>
                                <td>
                                    <strong>
                                        {domainData.nl}
                                        {sign}
                                    </strong>
                                    <small>/{t('titles.year')}</small>
                                    <div className="renewal">
                                        {t('domain-page.tlds-table.renewal')}: {domainData.nl}
                                        {sign}
                                    </div>
                                </td>
                                <td>
                                    <strong>
                                        {domainData.nl}
                                        {sign}
                                    </strong>
                                    <div className="renewal">
                                        {t('domain-page.tlds-table.year-included')}
                                    </div>
                                </td>
                            </tr>
                            <tr className="row-ru">
                                <td className="tld">
                                    <div className="saleeu gb-label--sale">
                                        <span>{t('domain-page.tlds-table.europe')}</span>
                                    </div>
                                    <strong>.ru</strong>
                                </td>
                                <td>
                                    <strong>
                                        {domainData.ru}
                                        {sign}
                                    </strong>
                                    <small>/{t('titles.year')}</small>
                                    <div className="renewal">
                                        {t('domain-page.tlds-table.renewal')}: {domainData.ru}
                                        {sign}
                                    </div>
                                </td>
                                <td>
                                    <strong>
                                        {domainData.ru}
                                        {sign}
                                    </strong>
                                    <div className="renewal">
                                        {t('domain-page.tlds-table.year-included')}
                                    </div>
                                </td>
                            </tr>
                            <tr className="row-info">
                                <td className="tld">
                                    <div className="salegeneric gb-label--sale">
                                        <span>{t('domain-page.tlds-table.generic')}</span>
                                    </div>
                                    <strong>.info</strong>
                                </td>
                                <td>
                                    <strong>
                                        {domainData.info}
                                        {sign}
                                    </strong>
                                    <small>/{t('titles.year')}</small>
                                    <div className="renewal">
                                        {t('domain-page.tlds-table.renewal')}: {domainData.info}
                                        {sign}
                                    </div>
                                </td>
                                <td>
                                    <strong>
                                        {domainData.info}
                                        {sign}
                                    </strong>
                                    <div className="renewal">
                                        {t('domain-page.tlds-table.year-included')}
                                    </div>
                                </td>
                            </tr>
                            <tr className="row-xyz">
                                <td className="tld">
                                    <div className="salegeneric gb-label--sale">
                                        <span>{t('domain-page.tlds-table.generic')}</span>
                                    </div>
                                    <strong>.xyz</strong>
                                </td>
                                <td>
                                    <strong>
                                        {domainData.xyz}
                                        {sign}
                                    </strong>
                                    <small>/{t('titles.year')}</small>
                                    <div className="renewal">
                                        {t('domain-page.tlds-table.renewal')}: {domainData.xyz}
                                        {sign}
                                    </div>
                                </td>
                                <td>
                                    <strong>
                                        {domainData.xyz}
                                        {sign}
                                    </strong>
                                    <div className="renewal">
                                        {t('domain-page.tlds-table.year-included')}
                                    </div>
                                </td>
                            </tr>
                            <tr className="row-io">
                                <td className="tld">
                                    <div className="salegeneric gb-label--sale">
                                        <span>{t('domain-page.tlds-table.generic')}</span>
                                    </div>
                                    <strong>.io</strong>
                                </td>
                                <td>
                                    <strong>
                                        {domainData.io}
                                        {sign}
                                    </strong>
                                    <small>/{t('titles.year')}</small>
                                    <div className="renewal">
                                        {t('domain-page.tlds-table.renewal')}: {domainData.io}
                                        {sign}
                                    </div>
                                </td>
                                <td>
                                    <strong>
                                        {domainData.io}
                                        {sign}
                                    </strong>
                                    <div className="renewal">
                                        {t('domain-page.tlds-table.year-included')}
                                    </div>
                                </td>
                            </tr>
                            <tr className="row-pro">
                                <td className="tld">
                                    <div className="salegeneric gb-label--sale">
                                        <span>{t('domain-page.tlds-table.generic')}</span>
                                    </div>
                                    <strong>.pro</strong>
                                </td>
                                <td>
                                    <strong>
                                        {domainData.pro}
                                        {sign}
                                    </strong>
                                    <small>/{t('titles.year')}</small>
                                    <div className="renewal">
                                        {t('domain-page.tlds-table.renewal')}: {domainData.pro}
                                        {sign}
                                    </div>
                                </td>
                                <td>
                                    <strong>
                                        {domainData.pro}
                                        {sign}
                                    </strong>
                                    <div className="renewal">
                                        {t('domain-page.tlds-table.year-included')}
                                    </div>
                                </td>
                            </tr>
                            <tr className="row-us">
                                <td className="tld">
                                    <div className="saleamerica gb-label--sale">
                                        <span>{t('domain-page.tlds-table.america')}</span>
                                    </div>
                                    <strong>.us</strong>
                                </td>
                                <td>
                                    <strong>
                                        {domainData.us}
                                        {sign}
                                    </strong>
                                    <small>/{t('titles.year')}</small>
                                    <div className="renewal">
                                        {t('domain-page.tlds-table.renewal')}: {domainData.us}
                                        {sign}
                                    </div>
                                </td>
                                <td>
                                    <strong>
                                        {domainData.us}
                                        {sign}
                                    </strong>
                                    <div className="renewal">
                                        {t('domain-page.tlds-table.year-included')}
                                    </div>
                                </td>
                            </tr>
                            <tr className="row-in">
                                <td className="tld">
                                    <div className="saleasia gb-label--sale">
                                        <span>{t('domain-page.tlds-table.asia')}</span>
                                    </div>
                                    <strong>.in</strong>
                                </td>
                                <td>
                                    <strong>
                                        {domainData.in}
                                        {sign}
                                    </strong>
                                    <small>/{t('titles.year')}</small>
                                    <div className="renewal">
                                        {t('domain-page.tlds-table.renewal')}: {domainData.in}
                                        {sign}
                                    </div>
                                </td>
                                <td>
                                    <strong>
                                        {domainData.in}
                                        {sign}
                                    </strong>
                                    <div className="renewal">
                                        {t('domain-page.tlds-table.year-included')}
                                    </div>
                                </td>
                            </tr>
                            <tr className="row-ma">
                                <td className="tld">
                                    <div className="saleafrica gb-label--sale">
                                        <span>{t('domain-page.tlds-table.africa')}</span>
                                    </div>
                                    <strong>.ma</strong>
                                </td>
                                <td>
                                    <strong>
                                        {domainData.ma}
                                        {sign}
                                    </strong>
                                    <small>/{t('titles.year')}</small>
                                    <div className="renewal">
                                        {t('domain-page.tlds-table.renewal')}: {domainData.ma}
                                        {sign}
                                    </div>
                                </td>
                                <td>
                                    <strong>
                                        {domainData.ma}
                                        {sign}
                                    </strong>
                                    <div className="renewal">
                                        {t('domain-page.tlds-table.year-included')}
                                    </div>
                                </td>
                            </tr>
                            <tr className="row-bi">
                                <td className="tld">
                                    <div className="saleafrica gb-label--sale">
                                        <span>{t('domain-page.tlds-table.africa')}</span>
                                    </div>
                                    <strong>.bi</strong>
                                </td>
                                <td>
                                    <strong>
                                        {domainData.bi}
                                        {sign}
                                    </strong>
                                    <small>/{t('titles.year')}</small>
                                    <div className="renewal">
                                        {t('domain-page.tlds-table.renewal')}: {domainData.bi}
                                        {sign}
                                    </div>
                                </td>
                                <td>
                                    <strong>
                                        {domainData.bi}
                                        {sign}
                                    </strong>
                                    <div className="renewal">
                                        {t('domain-page.tlds-table.year-included')}
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </Col>
            </Row>
            <Row>
                <Nav className="common-nav-button yellow">
                    <Nav.Link
                        className="navbar-brand"
                        onClick={() => {
                            window.scrollTo({ top: 0, behavior: 'smooth' });
                        }}
                    >
                        {t('buttons.see-full-tlds')}
                    </Nav.Link>
                </Nav>
            </Row>
        </div>
    );
}

export default DomainWidget;
